import { useState, useEffect } from 'react';
import { SurveyStatus } from '@models';
import { SurveyStore } from '@app/api';

export const useCohortSurveys = (cohortId: number, enabled: boolean) => {
  const [surveys, setSurveys] = useState<SurveyStatus[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const loadSurveys = async () => {
      setLoading(true);
      try {
        const store = new SurveyStore();
        const response = await store.getCohortSurveyStatus(cohortId);
        if (response.status === 'SUCCESS' && response.result) {
          setSurveys(response.result);
        }
      } catch (error) {
        console.error('Failed to load surveys:', error);
      } finally {
        setLoading(false);
      }
    };

    loadSurveys();
  }, [cohortId, enabled]);

  return { surveys, loading };
};
